<a [routerLink]="['/']">
  <h1>
  	<img src="assets/img/cebac.svg" class="logo" alt="Comann Eachdraidh logo"/>
  	Comann Shop</h1>
</a>

<a [routerLink]="['/basket']" class="button fancy-button" matBadge="{{ this.basketService.getNumberOfItems() }}"><mat-icon svgIcon="basket" aria-hidden="false" aria-label="view basket and checkout"></mat-icon> <span class="label">Checkout</span></a>

